// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"TextField__pc_only___2fQ7E","sp_only":"TextField__sp_only___1IhB6","textfield":"TextField__textfield___3ANBv","required":"TextField__required___X9YNN"};